import InputImage from "../../components/Atomos/InputImage/InputImage";
import { useEventImages } from "../../hooks/Events/EventImagesContext";

const Graphics = () => {
  const {
    bannerLists,
    bannerDetails,
    bannerHomePage,
    bannerInvoice,
    handleBannerListsChange,
    handleBannerDetailsChange,
    handleBannerHomePageChange,
    handleBannerInvoiceChange,
  } = useEventImages();

  return (
    <div className="grid grid-cols-12 gap-4 md:gap-6 lg:gap-8">
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <InputImage
          title="Event List Banner"
          setImage={handleBannerListsChange}
          photo={typeof bannerLists === "string" ? bannerLists : ""}
          maxsize={25}
          width={210}
          height={240}
          adaptiveShape
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <InputImage
          title="Event Details Banner"
          setImage={handleBannerDetailsChange}
          photo={typeof bannerDetails === "string" ? bannerDetails : ""}
          maxsize={25}
          width={514}
          height={334}
          adaptiveShape
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <InputImage
          title="Home Page Banner"
          setImage={handleBannerHomePageChange}
          photo={typeof bannerHomePage === "string" ? bannerHomePage : ""}
          maxsize={25}
          width={200}
          height={255}
          adaptiveShape
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <InputImage
          title="Invoice Banner"
          setImage={handleBannerInvoiceChange}
          photo={typeof bannerInvoice === "string" ? bannerInvoice : ""}
          maxsize={25}
          width={750}
          height={220}
          adaptiveShape
        />
      </div>
    </div>
  );
};

export default Graphics;